import api from "./api";

export function getVisaDocumentPage(country_id) {
  return api.get(`/visadocument/${country_id}`);
}

export function createVisaDocumentPage(data) {
  return api.post("/visadocument", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateVisaDocumentPage(country_id, data) {
  return api.put(`/visadocument/${country_id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
